module.exports = {
	"scheduleEditor": {
		"title": "ערוך זמינות חניה",
		"legend": {
			"title": "מקרא צבעים",
			"privateUse": "חניה בשימוש פרטי",
			"available": "חניה זמינה להשכרה",
			"past": "זמינות בעבר (לא ניתן לשינוי)",
			"nonRepeating": "חניה זמינה (חד-פעמי)",
			"variation": "שינוי",
			"shutdown": "חניה כבויה",
			"new": "שינוי חדש (טרם נשמר)",
			"preorder": "הזמנה מוקדמת"
		},
		"deleteDialog": {
			"title": "אפס זמינות",
			"fromDate": "מתאריך",
			"fromTime": "משעה",
			"toDate": "עד תאריך",
			"toTime": "שעה"
		},
		"confirmDelete": {
			"title": "מחיקת לו״ז חוזר",
			"message": "האם ברצונך למחוק רק אירוע זה, את כל האירועים בסדרת האירועים החוזרים, או אירוע זה ואת האירועים העתידיים בסדרת האירועים החוזרים?",
			"once": {
				"buttonText": "רק אירוע זה",
				"description": "כל שאר האירועים החוזרים יישארו כפי שהם.",
				"help": " "
			},
			"following": {
				"buttonText": "כל הבאים",
				"description": "אירוע זה וכל האירועים הבאים אחריו יימחקו.",
				"help": " "
			},
			"all": {
				"buttonText": "כל האירועים בסדרה",
				"description": "כל האירועים החוזרים יימחקו.",
				"help": " "
			}
		},
		"confirmEdit": {
			"title": "עריכת לו״ז חוזר",
			"message": "האם ברצונך לשנות רק את האירוע הזה, את כל האירועים בסדרת האירועים החוזרים או את האירוע הזה ואת כל האירועים הבאים אחריו בסדרה?",
			"once": {
				"buttonText": "רק אירוע זה",
				"description": "כל שאר האירועים בסדרה יישארו כפי שהם.",
				"help": " "
			},
			"following": {
				"buttonText": "האירועים הבאים",
				"description": "אירוע זה וכל האירועים הבאים אחריו ישונו.",
				"help": "כל השינויים באירועים עתידיים יאבדו."
			},
			"all": {
				"buttonText": "כל האירועים",
				"description": "כל האירועים בסדרה ישונו.",
				"help": "כל השינויים שנעשו באירועים אחרים יאבדו."
			}
		},
		"editDialog": {
			"title": "ערוך זמינות חניה",
			"addMode.title": "הוסף זמינות חניה",
			"viewMode.title": "Edit recurring schedule",
			"fromDate": "מתאריך",
			"fromTime": "משעה",
			"toDate": "עד תאריך",
			"toTime": "עד שעה",
			"recurring": "לו״ז מחזורי",
			"description": {
				"DAILY": "חוזר כל יום",
				"WEEKLY": "חוזר כל שבוע בימים",
				"MONTHLY": "חוזר ב- {{date}} בכל חודש",
				"YEARLY": "חוזר ב-{{date}} בכל שנה",
				"until": "עד",
				"forever": "לנצח"
			},
			"overrideVariants": "דרוס שינויים",
			"warnEditingPast": "שימו לב! לא ניתן לשנות אירועי עבר. השינויים יחולו רק עבור לו״ז עתידי."
		}
	},
	"Schedule updated": "הלו״ז עודכן בהצלחה",
	"Schedule deleted": "הלו״ז נמחק בהצלחה",
	"Schedule added": "הלו״ז נשמר בהצלחה",
	"Changes saved": "השינויים נשמרו בהצלחה",
	"Changes reset": "השינויים אופסו בהצלחה",
	"Nothing changed": "אין שינויים",
	"You cannot alter the past": "לא ניתן לשנות את העבר",
	"Error loading schedules": "שגיאה בטעינת הלו״ז",
	"End date cannot be smaller than Start date": "תאריך התחלה אינו יכול להיות אחרי תאריך סיום",
	"End time cannot be smaller than Start time": "זמן התחלה אינו יכול להיות אחרי זמן סיום",
	"No days selected": "לא נבחרו ימים",
	"DayOfWeek": {
		"0": "שני",
		"1": "שלישי",
		"2": "רביעי",
		"3": "חמישי",
		"4": "שישי",
		"5": "שבת",
		"6": "ראשון",
		"short": {
			"0": "ב׳",
			"1": "ג׳",
			"2": "ד׳",
			"3": "ה׳",
			"4": "ו׳",
			"5": "ש׳",
			"6": "א׳"
		}
	},
	"RepeatType": {
		"0": "כל יום",
		"1": "כל שבוע",
		"2": "כל חודש",
		"3": "כל שנה"
	},
	"button": {
		"ok": "אישור",
		"save": "שמור",
		"reset": "אפס שינויים",
		"add": "הוסף",
		"delete": "מחק",
		"legend": "מקרא",
		"cancel": "ביטול",
		"close": "סגור",
		"help": "עזרה"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/shared/translator/translations-he.config.yml
 ** module id = 904
 ** module chunks = 0
 **/